import { type FC } from 'react';
import { IconButton } from '@chakra-ui/react';
import { ReactComponent as GoBack1hIcon } from '../../../assets/svg/GoBack1hIcon.svg';
import { translate } from '../../../constants/translation';
import { Timestamp } from '../../../services/Timestamp';
import { useAppInsights } from '../../../hooks/useAppInsights';
import { getEventFactory } from '../../../utils/get-event-factory';
import { Event } from '../../../types';

interface Props {
  timestamp: Timestamp;
  setTimestamp: (timestamp: Timestamp) => void;
  setStartTimestamp: (timestamp: Timestamp) => void;
  operation: string;
}

const JumpBackButton: FC<Props> = ({ timestamp, setStartTimestamp, setTimestamp, operation }): JSX.Element => {
  const appInsights = useAppInsights();

  const handleJump = (): void => {
    const newTimestamp = timestamp.subtract(Timestamp.fromHours(1));
    setTimestamp(newTimestamp);
    setStartTimestamp(newTimestamp);

    const event = getEventFactory(Event.JumpBackButtonClicked)(operation, newTimestamp);
    appInsights.trackAnalyticsEvent(event);
  };

  return (
    <div>
      <IconButton
        variant="secondary"
        icon={<GoBack1hIcon />}
        aria-label={translate('REPLAY_1H_AGO')}
        onClick={handleJump}
      />
    </div>
  );
};

export default JumpBackButton;
